import React, { useState } from 'react';
import styles from './GuidedPromptFlow.module.css'; // reuse existing styling for simplicity
import useMindspaceStore from '../../store/mindspaceStore';

interface ContextReviewStepProps {
  implicitKeys: string[];
  onContinue: (updatedValues: Record<string, string>) => void;
  onCancel: () => void;
}

// Simple Romanian labels mapping – can be expanded later
const KEY_LABELS: Record<string, string> = {
  product_service_description: 'Descriere produs/serviciu',
  target_audience_description: 'Descriere audiență țintă',
  brand_voice: 'Tonul vocii brandului',
  unique_selling_proposition: 'Propoziție unică de vânzare',
  key_benefits: 'Beneficii cheie',
  business_name: 'Numele afacerii',
  call_to_action_goal: 'Obiectiv CTA',
  list_of_competitors: 'Lista competitorilor',
  industry_description: 'Descriere industrie',
  business_stage: 'Stadiul afacerii',
  business_model: 'Model de business',
  growth_objective: 'Obiectiv de creștere',
  main_channel: 'Canal principal',
};

const ContextReviewStep: React.FC<ContextReviewStepProps> = ({ implicitKeys, onContinue, onCancel }) => {
  const mindspaceContext = useMindspaceStore((state) => state.contextItems);
  
  // Build initial values map from mindspace context
  const initialValues: Record<string, string> = {};
  implicitKeys.forEach((key) => {
    const existing = mindspaceContext.find((c) => c.item_type === key);
    initialValues[key] = existing?.content || '';
  });

  const [values, setValues] = useState<Record<string, string>>(initialValues);

  const handleChange = (key: string, v: string) => {
    setValues((prev) => ({ ...prev, [key]: v }));
  };

  const handleContinue = () => {
    onContinue(values);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.question}>Verifică informațiile de bază</h2>
      <p className={styles.progress} style={{ marginBottom: '12px' }}>
        Aceste informații vor fi folosite în răspunsul AI. Modifică-le dacă este nevoie.
      </p>

      {implicitKeys.map((key) => (
        <div key={key} style={{ marginBottom: '12px' }}>
          <label htmlFor={`ctx-${key}`} style={{ display: 'block', marginBottom: '4px', fontWeight: 600 }}>
            {KEY_LABELS[key] || key}
          </label>
          <textarea
            id={`ctx-${key}`}
            className={styles.input}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            placeholder={`Introdu ${KEY_LABELS[key] || key}...`}
          />
        </div>
      ))}

      <div className={styles.buttonRow}>
        <button className={`${styles.button} ${styles.secondary}`} onClick={onCancel}>
          Renunță
        </button>
        <button className={`${styles.button} ${styles.primary}`} onClick={handleContinue}>
          Continuă
        </button>
      </div>
    </div>
  );
};

export default ContextReviewStep; 